<script setup lang="ts">
import { mdiLoading } from '@mdi/js'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  title: string
  disabled?: boolean
  readonly?: boolean
  loading?: boolean
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    tabindex="-1"
    class="peer outline-none disabled:text-gray-500 disabled:fill-gray-400 disabled:shadow-none not-disabled:fill-gray-700"
    :class="readonly ? 'cursor-auto' : 'not-disabled:cursor-pointer'"
    :title="title"
    v-bind="$attrs"
  >
    <SvgIcon v-if="loading" :path="mdiLoading" class="fill-black animate-spin h-5 w-5" />
    <slot v-else></slot>
  </button>
</template>
